// skipcq: JS-W1028, JS-0128
import React from 'react';
import { Link } from 'react-router-dom';
import {
  CardContent,
  CardActions,
  Button,
  Typography,
  CircularProgress,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';
import { Store } from '@mui/icons-material';
import useUserAddedBreweriesCount from '../../hooks/useUserAddedBreweriesCount';
import DashboardSurfaceCard from './DashboardSurfaceCard';

function UserAddedBreweriesCard() {
  const { count, stateBreakdown, loading, error } = useUserAddedBreweriesCount();

  return (
    <DashboardSurfaceCard>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1
          }}>
          <Store color="primary" />
          <Typography variant="h6" component="h2">
            User-Added Breweries
          </Typography>
        </Box>
        <Typography variant="body2" paragraph sx={{
          color: "text.secondary"
        }}>
          Breweries added by users
        </Typography>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2
            }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            Error loading count
          </Typography>
        ) : (
          <Box>
            <Typography variant="h4" component="div" color="primary">
              {count.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mt: 1,
                mb: 2
              }}>
              Total user-added breweries
            </Typography>

            {stateBreakdown.length > 0 && (
              <>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "text.secondary",
                    mb: 1
                  }}>
                  Breakdown by State:
                </Typography>
                <List dense sx={{ maxHeight: 200, overflow: 'auto' }}>
                  {stateBreakdown.map((item, index) => (
                    <React.Fragment key={item.state}>
                      {index > 0 && <Divider component="li" />}
                      <ListItem disablePadding>
                        <ListItemText
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                              <Typography variant="body2">{item.state}</Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'medium', color: 'primary.main' }}
                              >
                                {item.count.toLocaleString()}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              </>
            )}
          </Box>
        )}
      </CardContent>
      <CardActions>
        <Button variant="outlined" component={Link} to="/user-added-locations" fullWidth>
          User Added Breweries
        </Button>
      </CardActions>
    </DashboardSurfaceCard>
  );
}

export default UserAddedBreweriesCard;
